import Tooltip from '@mui/material/Tooltip';
import { typedMemo } from '@utils';
import React, { useRef, useState } from 'react';

interface TooltipOnEllipsisProps {
  title: string;
  children: React.ReactNode;
}

export const TooltipOnEllipsis = typedMemo(
  ({ title, children }: Readonly<TooltipOnEllipsisProps>) => {
    const textRef = useRef<HTMLDivElement>(null);
    const [showTooltip, setShowTooltip] = useState(false);

    const handleTooltipOpen = () => {
      if (textRef.current) {
        const isOverflowing =
          textRef.current.scrollWidth > textRef.current.offsetWidth;
        setShowTooltip(isOverflowing);
      }
    };

    const handleTooltipClose = () => {
      setShowTooltip(false);
    };

    return (
      <Tooltip
        disableInteractive
        title={title}
        open={showTooltip}
        placement="top"
        enterDelay={500}
        enterNextDelay={500}
        onOpen={handleTooltipOpen}
        onClose={handleTooltipClose}
      >
        <div
          ref={textRef}
          role="text"
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '100%',
          }}
        >
          {children}
        </div>
      </Tooltip>
    );
  },
);
